import { Experiences } from '@luxuryescapes/contract-svc-experience';

/**
 * Resolves an image URL, applying Cloudinary transformations for public IDs.
 */
export function resolveImageUrl(url: string, width = 80, height = 50): string {
  return url.startsWith('http')
    ? url
    : `${window.configs.IMAGE_HOST}/fl_progressive,q_auto:eco,c_fill,g_auto,w_${width},h_${height}/${url}`;
}

export function resolveOfferImageUrl(img: Experiences.Image, width = 80, height = 50): string {
  const url = img.urls?.[0]?.url ?? '';
  return resolveImageUrl(url, width, height);
}
